import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router-dom';

type Props = {
    /** Name of the lumina App */
    appName: React.ReactNode;
    /** Image of the application logo */
    appLogo?: React.ReactElement;
    /** Description of the application */
    body: string;
    /** Link to the card application */
    link: string;
    /** should show skeleton loading when logging on. */
    isLoading: boolean,
    /** optional class to change style of cards */
    className?: string
    /** check if local link to use react-router for faster laoding */
    internalLink?: boolean;
};

const AppCard = (props: Props) => {
    const {
        appName,
        appLogo,
        body,
        link,
        isLoading,
        internalLink,
    } = props;
    const navigate = useNavigate();

    return (
        <>
            {isLoading
            && <button
                className={[
                    'flex flex-row mr-8 mt-8 p-6 items-start justify-items-center',
                    'bg-white border-1.5 shadow-card border-card-normal rounded-md',
                    'hover:border-card-hover outline-0 focus-visible:border-card-hover active:shadow-none',
                ].join(' ')}
                style={{
                    width: '29.5rem',
                    height: '9.6rem',
                }}
                onClick={ () => { window.location.href = link; }}
                type='button'>
                <Skeleton
                    circle={false}
                    style={{ width: '70px', height: '70px' }}
                    baseColor='#d7d7d7' highlightColor='#c8c8c8' className='mt-8 ml-8 items-start'/>
                <div className='flex flex-col text-left  mt-6 ml-8'>
                    <span className='text-label-xl font-bold'>
                        <Skeleton style={{ width: '10rem' }} baseColor='#d7d7d7' highlightColor='#c8c8c8'/>
                    </span>
                    <span className='md:text-paragraph-reg'>
                        <Skeleton style={{ width: '15rem' }} baseColor='#d7d7d7' highlightColor='#c8c8c8' />
                        <Skeleton style={{ width: '10rem' }} baseColor='#d7d7d7' highlightColor='#c8c8c8' />
                    </span>
                </div>
            </button>
            }
            {!isLoading
            && <>
                <button
                    className={[
                        'invisible md:visible absolute md:relative',
                        'flex flex-row mr-8 mt-8 p-6 items-start justify-items-center',
                        'bg-white border-1.5 shadow-card border-card-normal rounded-md',
                        'hover:border-card-hover outline-0 focus-visible:border-card-hover active:shadow-none',
                    ].join(' ')}
                    style={{
                        width: '29.5rem',
                        height: '9.6rem',
                    }}
                    onClick={() => {
                        if (internalLink) {
                            navigate(link);
                        } else {
                            window.location.href = link;
                        }
                    } }
                    type='button'>
                    <>
                        <span className='ml-8 w-shortcut place-self-center'>
                            {appLogo}
                        </span>
                        <div className='flex flex-col text-left ml-8  place-self-center '>
                            <span className='text-label-xl font-bold'>
                                {appName}
                            </span>
                            <span className='md:text-paragraph-reg'>
                                {body}
                            </span>
                        </div>
                    </>
                </button>
                {/* mobile component */}
                <button
                    className={[
                        'visible md:invisible relative md:absolute h-auto',
                        'flex flex-row mt-8 p-6 items-center justify-items-center',
                        'bg-white border-1.5 shadow-card border-card-normal rounded-md',
                        'hover:border-card-hover outline-0 focus-visible:border-card-hover active:shadow-none',
                    ].join(' ')}
                    style={{
                        width: '22rem',
                    }}
                    onClick={() => {
                        if (internalLink) {
                            navigate(link);
                        } else {
                            window.location.href = link;
                        }
                    } }
                    type='button'>
                    <>
                        <span className='ml-8 w-shortcut place-self-center'>
                            {appLogo}
                        </span>
                        <div className='flex flex-col text-left ml-8 mt-2 place-self-center '>
                            <span className='text-label-xl font-bold'>
                                {appName}
                            </span>
                        </div>
                    </>
                </button>
            </>
            }
        </>
    );
};

export default AppCard;